import * as React from 'react';
import styled from 'styled-components';
import { RouteMetaTs } from 'config/routes';
import { CommonTs } from '../../locales';
import Header from './header';
import Footer from './footer';

interface IProps {
  children: React.ReactNode;
  meta?: RouteMetaTs;
  messages: CommonTs;
  lang: string;
}


const LayoutStyle = ({ children, meta, messages, lang }: IProps) => {
  

  return (
  <Layout>
    <Header messages={messages} lang={lang} />
    <Middle layout={meta && meta.layout}>
      {children}
    </Middle>
    <Footer messages={messages} lang={lang} />
  </Layout>
)};

export default LayoutStyle;

const Layout = styled.div`
  padding: 0;
`;

interface MiddleProps {
  layout?: string;
}

const Middle = styled.div<MiddleProps>`
  margin: 0 auto;
  padding: 0 20px;
  width: ${p => p.layout === 'full' ? '100%' : '1240px'};
`;


// WEBPACK FOOTER //
// ./src/styles/layout/default.tsx